/**
 * Datos mock para Packing Masivo (preparación, órdenes, ubicaciones).
 * Se usan cuando USE_MASSIVE_PACKING_MOCKS está activo en config/mocks.ts.
 */
import type { Order } from '@modules/OrderPreparation/PackingV2/models';
import type { PreparationWithProducts } from '@modules/OrderPreparation/PackingV2/models';

// GET /preparations/{id} – type 1 (massive), con buckets
export const mockPreparation: PreparationWithProducts = {
  id: 9043,
  code: 'PREP-2510-4',
  type: 1,
  team_id: 63,
  status: 1,
  location_id: null,
  created_at: '2025-09-10T17:37:30+02:00',
  updated_at: '2026-02-10T08:40:00+02:00',
  total_orders: 4,
  buckets: [
    {
      id: 1,
      status: 'Por preparar',
      order_group_description: '1 Pedido con los mismos productos',
      quantity_of_orders_in_group: 1,
      order_ids: [56280],
      items: [
        {
          product_id: 141,
          product_name: 'Sujetador Negro L',
          code: 'BP005421',
          quantity: 1,
          image_url: null,
        },
      ],
    },
    {
      id: 2,
      status: 'Preparado',
      order_group_description: '1 Pedido con los mismos productos',
      quantity_of_orders_in_group: 1,
      order_ids: [56281],
      items: [
        {
          product_id: 142,
          product_name: 'Leggins moldeador largo verde 2XL',
          code: 'BP011871',
          quantity: 1,
          image_url: null,
        },
      ],
    },
    {
      id: 3,
      status: 'Por preparar',
      order_group_description: '1 Pedido con los mismos productos',
      quantity_of_orders_in_group: 1,
      order_ids: [56282],
      items: [
        {
          product_id: 143,
          product_name: 'Leggins moldeador largo Negro L',
          code: 'BP005459',
          quantity: 1,
          image_url: null,
        },
      ],
    },
    {
      id: 4,
      status: 'Por preparar',
      order_group_description: '1 Pedido con los mismos productos',
      quantity_of_orders_in_group: 1,
      order_ids: [56283],
      items: [
        {
          product_id: 144,
          product_name: 'Sujetador Marrón XL',
          code: 'BP010760',
          quantity: 1,
          image_url: null,
        },
        {
          product_id: 145,
          product_name: 'Leggins moldeador largo azul XL',
          code: 'BP011864',
          quantity: 1,
          image_url: null,
        },
      ],
    },
  ],
  lines: [],
};

// GET /orders?preparation_ids=9043 – órdenes que coinciden con los buckets (56280–56283)
export const mockOrders: Order[] = [
  {
    id: 56280,
    ref: '#ORD-56280',
    status_id: 1,
    order_created_at: '2025-09-10T10:00:00+02:00',
    shop: { id: 5, name: 'Tienda Demo' },
    customer: { name: 'Cliente Demo 1' },
    shipment: { processed_at: undefined },
    lines: [],
  },
  {
    id: 56281,
    ref: '#ORD-56281',
    status_id: 1,
    order_created_at: '2025-09-10T10:05:00+02:00',
    shop: { id: 5, name: 'Tienda Demo' },
    customer: { name: 'Cliente Demo 2' },
    shipment: { processed_at: '2026-02-10T08:00:00+02:00' },
    lines: [],
  },
  {
    id: 56282,
    ref: '#ORD-56282',
    status_id: 1,
    order_created_at: '2025-09-10T10:10:00+02:00',
    shop: { id: 5, name: 'Tienda Demo' },
    customer: { name: 'Cliente Demo 3' },
    shipment: { processed_at: undefined },
    lines: [],
  },
  {
    id: 56283,
    ref: '#ORD-56283',
    status_id: 1,
    order_created_at: '2025-09-10T10:15:00+02:00',
    shop: { id: 5, name: 'Tienda Demo' },
    customer: { name: 'Cliente Demo 4' },
    shipment: { processed_at: undefined },
    lines: [],
  },
];

// GET /locations?product_ids=141,142,143 – ubicaciones por producto (para agrupar por product_id)
const mockLocationsRaw = [
  { id: 278, code: 'A-01-01', product_id: 141, stock: 50 },
  { id: 279, code: 'A-01-02', product_id: 141, stock: 30 },
  { id: 280, code: 'B-02-01', product_id: 142, stock: 20 },
  { id: 281, code: 'B-02-02', product_id: 142, stock: 15 },
  { id: 282, code: 'C-03-01', product_id: 143, stock: 8 },
];

export const mockLocationsByProduct: Record<number, Array<{ id: number; code: string; stock: number; product_id: number }>> = (() => {
  const byProduct: Record<number, Array<{ id: number; code: string; stock: number; product_id: number }>> = {};
  mockLocationsRaw.forEach((loc) => {
    if (!byProduct[loc.product_id]) byProduct[loc.product_id] = [];
    byProduct[loc.product_id].push({
      id: loc.id,
      code: loc.code,
      stock: loc.stock,
      product_id: loc.product_id,
    });
  });
  return byProduct;
})();
